import type React from "react";
import type {Annotation} from "../ImageAnnotation.js";
import {shapeService} from "../shape.service.js";

type EditionLayerProps = {
  width: number;
  height: number;
  annotation: Annotation;
  onTextEdit: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTextEdited: () => void;
  onDelete: () => void;
};
export function EditLayer({
  width,
  height,
  annotation,
  onTextEdited,
  onDelete,
  onTextEdit,
}: EditionLayerProps) {
  const {color, label} = annotation;
  const {x, y} = shapeService.getTextLocation(width, height, annotation);
  let finalX = x;
  if (x + 120 + 10 + 28 > width) {
    finalX = width - 120 - 10 - 28;
  }
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: `${y}px`,
          left: `${finalX}px`,
          zIndex: 1000,
        }}
      >
        <input
          type="text"
          value={label}
          onChange={onTextEdit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onTextEdited();
            }
          }}
          style={{
            borderRadius: "4px",
            padding: "2px 4px",
            fontSize: "15px",
            color: "#000000",
            width: "120px",
            border: `1px solid ${color}`,
          }}
        />
      </div>
      <div
        style={{
          position: "absolute",
          top: `${y}px`,
          left: `${finalX + 120 + 10}px`,
          zIndex: 1000,
        }}
      >
        <button
          className="delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          style={{
            background: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "2px 8px",
            cursor: "pointer",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "28px",
            width: "28px",
          }}
        >
          ×
        </button>
      </div>
    </>
  );
}
